import React, { useState, useEffect, useRef } from "react"; // ← add useRef
import emailjs from "@emailjs/browser";

const initialForm = { name: "", email: "", message: "" };

// Initialize EmailJS (do this once when app loads)
// // Get these from https://dashboard.emailjs.com/


const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY_Live;
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID_Live;
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID__Live_Contact;

export default function Contact() {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState("");

  // Initialize EmailJS on component mount
  useEffect(() => {
    emailjs.init(EMAILJS_PUBLIC_KEY);
  }, []);

  const sendUserMessge = useRef(null); // ← add this

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Name is required";
    if (!form.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      e.email = "Valid email is required";
    // if (!form.message.trim() || form.message.trim().length < 10)
    //   e.message = "Please enter a message (min 10 characters)";
    return e;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
    if (submitError) setSubmitError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError("");


   const errs = validate();
if (Object.keys(errs).length > 0) {
  setErrors(errs);
  sendUserMessge.current?.scrollIntoView({ behavior: "smooth", block: "start" }); // ← add this
  return;
}

    setLoading(true);

    try {
      // console.log("EMAILJS_PUBLIC_KEY",EMAILJS_PUBLIC_KEY)
      // Send email using EmailJS
      const response = await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          to_email: "operations@load2server.com", // Change to your email
          from_name: form.name,
          from_email: form.email,
          message: form.message,
          reply_to: form.email, // Allow replies to user's email
        },
      );

      if (response.status === 200) {
        console.log("Email sent successfully!");
        setSubmitted(true);
        setForm(initialForm);
        // window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        setSubmitError("Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("EmailJS Error:", error);
      setSubmitError(
        error.text ||
          "Failed to send message. Please check your connection and try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const inputClass = (field) =>
    `w-full form-input border rounded-xl px-4 py-3 text-sm text-slate-800 placeholder-slate-400 bg-slate-50 transition-all duration-200 focus:bg-white ${
      errors[field] ? "border-red-400 bg-red-50/30" : "border-slate-200"
    }`;

  const contactInfo = [
    {
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      ),
      label: "Our Office",
      value: "6202 Healy RdCaledon East, On L7C0W7",
    },
    {
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      ),
      label: "Email Us",
      value: "info@load2serve.com\nsupport@load2serve.com",
    },
    {
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
      ),
      label: "Call Us",
      value: "+1 (343) 265-0527",
    },
    {
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
      label: "Business Hours",
      value: "Mon – Fri: 9:00 AM – 7:00 PM\nSat: 10:00 AM – 4:00 PM",
    },
  ];

  return (
    <div className="min-h-screen bg-slate-50 pt-16">
      {/* Page header */}
      <div className="bg-gradient-to-br from-slate-900 via-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <span className="text-blue-300 font-semibold text-sm uppercase tracking-widest">
            We're Here to Help
          </span>
          <h1 className="text-3xl sm:text-4xl font-black mt-3 mb-4">
            Get In Touch
          </h1>
          <p className="text-blue-200 max-w-xl mx-auto text-base">
            Have questions about our services? Need help with a shipment? Our
            team is always ready to assist you.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          {/* Left: Contact info */}
          <div className="lg:col-span-2 space-y-5">
            {/* Info cards */}
            {contactInfo.map((info) => (
              <div
                key={info.label}
                className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm flex gap-4 card-hover"
              >
                <div className="w-11 h-11 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600 flex-shrink-0">
                  {info.icon}
                </div>
                <div>
                  <div className="text-xs font-bold text-slate-400 uppercase tracking-wide mb-1">
                    {info.label}
                  </div>
                  <div className="text-sm text-slate-700 leading-relaxed whitespace-pre-line">
                    {info.value}
                  </div>
                </div>
              </div>
            ))}

            {/* Map placeholder */}
            {/* <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
              <div className="relative h-48 bg-gradient-to-br from-blue-50 to-slate-100 flex items-center justify-center">
                {/* Stylized map placeholder */}
                {/* <div
                  className="absolute inset-0 opacity-30"
                  style={{
                    backgroundImage:
                      "linear-gradient(rgba(59,130,246,0.2) 1px, transparent 1px), linear-gradient(90deg, rgba(59,130,246,0.2) 1px, transparent 1px)",
                    backgroundSize: "24px 24px",
                  }}
                />
                {/* <div className="relative z-10 text-center">
                  <div className="w-10 h-10 bg-blue-700 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg">
                    <svg
                      className="w-5 h-5 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <span className="text-sm font-semibold text-slate-600">
                    Mumbai, India
                  </span>
                  <p className="text-xs text-slate-400 mt-1">Load2Serve HQ</p>
                </div> */}
              {/* </div>
              <div className="px-5 py-3 border-t border-slate-100">
                <a
                  href="https://maps.google.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-blue-600 hover:text-blue-800 font-semibold flex items-center gap-1 transition-colors"
                >
                  Open in Google Maps →
                </a>
              </div> */}
            {/* </div> */} 
          </div>

          {/* Right: Contact form */}
          <div ref={sendUserMessge} className="lg:col-span-3">
            <div className="bg-white rounded-3xl shadow-xl shadow-slate-200/80 border border-slate-100 p-8 sm:p-10">
              {submitted ? (
                <div className="text-center py-10">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5">
                    <svg
                      className="w-8 h-8 text-green-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-black text-slate-900 mb-2">
                    Message Sent!
                  </h3>
                  <p className="text-slate-500 mb-6">
                    Thanks for reaching out. We'll respond to you at{" "}
                    <strong>{form.email}</strong> within 24 hours.
                  </p>
                  <button
                    onClick={() => {
                      setForm(initialForm);
                      setSubmitted(false);
                    }}
                    className="bg-blue-700 hover:bg-blue-800 text-white font-semibold px-6 py-3 rounded-xl transition-colors duration-200 text-sm"
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (
                <>
                <div  >
                  <h2 className="text-xl font-black text-slate-900 mb-1">
                    Send Us a Message
                  </h2>
                  <p className="text-sm text-slate-400 mb-7">
                    We typically respond within a few business hours.
                  </p>
                  </div>

                  {/* Error message */}
                  {submitError && (
                    <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl">
                      <p className="text-sm text-red-700 font-medium">
                        {submitError}
                      </p>
                    </div>
                  )}

                  <form onSubmit={handleSubmit} className="space-y-5">
                    <div>
                      <label className="block text-xs font-semibold text-slate-600 mb-1.5 uppercase tracking-wide">
                        Your Name *
                      </label>
                      <input
                        maxLength={30}
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        placeholder="John Smith"
                        className={inputClass("name")}
                        disabled={loading}
                      />
                      {errors.name && (
                        <p className="text-xs text-red-500 mt-1">
                          {errors.name}
                        </p>
                      )}
                    </div>

                    <div>
                      <label className="block text-xs font-semibold text-slate-600 mb-1.5 uppercase tracking-wide">
                        Email Address *
                      </label>
                      <input
                        maxLength={30}
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="john@company.com"
                        className={inputClass("email")}
                        disabled={loading}
                      />
                      {errors.email && (
                        <p className="text-xs text-red-500 mt-1">
                          {errors.email}
                        </p>
                      )}
                    </div>

                    <div>
                      <label className="block text-xs font-semibold text-slate-600 mb-1.5 uppercase tracking-wide">
                        Message *
                      </label>
                      <textarea
                        name="message"
                        value={form.message}
                        onChange={handleChange}
                        rows={6}
                        placeholder="How can we help you? Tell us about your logistics needs..."
                        className={`${inputClass("message")} resize-none`}
                        disabled={loading}
                      />
                      {errors.message && (
                        <p className="text-xs text-red-500 mt-1">
                          {errors.message}
                        </p>
                      )}
                    </div>

                    <button
                      type="submit"
                      disabled={loading}
                      className="w-full bg-blue-700 hover:bg-blue-800 disabled:bg-blue-600 disabled:cursor-not-allowed text-white font-bold py-4 rounded-xl text-sm transition-all duration-300 hover:shadow-xl hover:shadow-blue-700/30 hover:-translate-y-0.5 active:translate-y-0 flex items-center justify-center gap-2"
                    >
                      {loading ? (
                        <>
                          <svg
                            className="w-4 h-4 animate-spin"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth={4}
                            />
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            />
                          </svg>
                          Sending...
                        </>
                      ) : (
                        <>
                          Send Message
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2.5}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                            />
                          </svg>
                        </>
                      )}
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
